module.exports = __webpack_public_path__ + "static/banner-fee1f58459a0f92f7d53c36adc80ffcd.jpg";